import React from 'react';
import { Link } from 'react-router-dom';

export function PublicFooter() {
  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8 px-4 sm:px-6" data-testid="public-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-10 mb-14">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src="/harmonix-logo-dark.png" alt="Harmonix" className="h-10 w-auto" />
            </div>
            {/* Copy contrast bumped iter124 — slate-400 on slate-900 hovered
                just above the WCAG threshold and rendered near-invisible on
                mobile / dark-mode-mimicking browsers. slate-300 stays on
                brand while lifting contrast well above AA. */}
            <p className="text-sm text-slate-300 leading-relaxed max-w-sm mb-6">
              Your first AI employee. Built for service businesses that never want to miss a client again. Available 24/7 across every channel.
            </p>
            <p className="text-xs text-slate-400">Governed AI Communication</p>
          </div>
          <div>
            <p className="font-semibold text-sm mb-4 text-white">Product</p>
            <div className="space-y-2.5 text-sm text-slate-300">
              <Link to="/#pricing" className="block hover:text-teal-300 transition-colors">Pricing</Link>
              <Link to="/industries" className="block hover:text-teal-300 transition-colors">Industries</Link>
              <Link to="/use-cases" className="block hover:text-teal-300 transition-colors">Use Cases</Link>
              <Link to="/locations" className="block hover:text-teal-300 transition-colors">Locations</Link>
              <Link to="/docs/user-manual" className="block hover:text-teal-300 transition-colors">Documentation</Link>
            </div>
          </div>
          <div>
            <p className="font-semibold text-sm mb-4 text-white">Resources</p>
            <div className="space-y-2.5 text-sm text-slate-300">
              <Link to="/blog" className="block hover:text-teal-300 transition-colors">Blog</Link>
              <Link to="/case-studies" className="block hover:text-teal-300 transition-colors">Case Studies</Link>
              <Link to="/faq" className="block hover:text-teal-300 transition-colors">FAQ</Link>
              <Link to="/reseller" className="block hover:text-teal-300 transition-colors">Partners</Link>
              <Link to="/small-business" className="block hover:text-teal-300 transition-colors">Small Business</Link>
              <Link to="/enterprise" className="block hover:text-teal-300 transition-colors">Enterprise</Link>
            </div>
          </div>
          <div>
            <p className="font-semibold text-sm mb-4 text-white">Legal</p>
            <div className="space-y-2.5 text-sm text-slate-300">
              <Link to="/privacy" className="block hover:text-teal-300 transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="block hover:text-teal-300 transition-colors">Terms of Service</Link>
              <Link to="/refund" className="block hover:text-teal-300 transition-colors">Refund Policy</Link>
              <Link to="/cookies" className="block hover:text-teal-300 transition-colors">Cookie Policy</Link>
              <a href="mailto:support@harmonix.info" className="block hover:text-teal-300 transition-colors">Contact Us</a>
            </div>
          </div>
        </div>
        <div className="border-t border-slate-700 pt-8 flex flex-col items-center gap-4 text-xs text-slate-400">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 w-full">
            <p>&copy; {new Date().getFullYear()} Harmonix. All rights reserved.</p>
            <div className="flex items-center gap-4">
              <Link to="/privacy" className="hover:text-white">Privacy</Link>
              <Link to="/terms" className="hover:text-white">Terms</Link>
              <Link to="/cookies" className="hover:text-white">Cookies</Link>
            </div>
          </div>
          <p className="text-slate-500" data-testid="footer-velorien">Powered by VELORIEN GROUP LLC</p>
        </div>
      </div>
    </footer>
  );
}
